import { PromptSuggestion } from '../types';
import { slice } from '../../../../utils';
import { useTranslation } from 'react-i18next';

interface PromptSuggestionsProps {
    suggestions: PromptSuggestion[];
    onSuggestionClick: (prompt: string) => void;
    /** Grille 2×2 type maquette interview / analyse */
    variant?: 'default' | 'modern';
}

const toneClass = (tone: PromptSuggestion['tone']) => {
    switch (tone) {
        case 'coral':
            return 'ca-sug-icon--coral';
        case 'amber':
            return 'ca-sug-icon--amber';
        case 'accent':
            return 'ca-sug-icon--accent';
        case 'blue':
        default:
            return 'ca-sug-icon--blue';
    }
};

export const PromptSuggestions = ({ suggestions, onSuggestionClick, variant = 'default' }: PromptSuggestionsProps) => {
    const { t } = useTranslation();

    if (variant === 'modern') {
        return (
            <div className="ca-sug-block">
                <div className="ca-sug-grid">
                    {suggestions.map((suggestion, index) => (
                        <button
                            type="button"
                            key={index}
                            className="ca-sug-card"
                            onClick={() => onSuggestionClick(suggestion.prompt)}
                        >
                            <div className={`ca-sug-icon ${toneClass(suggestion.tone)}`}>{suggestion.icon}</div>
                            <div className="ca-sug-text">
                                <div className="ca-sug-title">{slice(suggestion.title, 80)}</div>
                                <div className="ca-sug-desc">{slice(suggestion.description, 160)}</div>
                            </div>
                        </button>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className="grid gap-2 mb-4 mt-4">
            <h6 className="text-light">{t('features.swimlane.suggestions')}</h6>
            {suggestions.map((suggestion, index) => (
                <button
                    key={index}
                    onClick={() => onSuggestionClick(suggestion.prompt)}
                    className="flex items-center gap-3 p-2 bg-blue-50 text-left hover:bg-gray-50 rounded-lg border border-gray-200 transition-colors group"
                >
                    <div className="p-2 bg-blue-50 rounded-lg text-blue-600 group-hover:bg-blue-100">
                        {suggestion.icon}
                    </div>
                    <div>
                        <h3 className="font-medium text-gray-900 text-xs">{slice(suggestion.title, 50)}</h3>
                        {/* <p className="text-xs text-gray-500">{slice(suggestion.description, 120)}</p> */}
                    </div>
                </button>
            ))}
        </div>
    );
};